export default __webpack_public_path__ + "static/media/AACLogo7.62a628ea.png";